import { render, staticRenderFns } from "./Clause.vue?vue&type=template&id=0f767622&scoped=true&"
import script from "./Clause.vue?vue&type=script&lang=js&"
export * from "./Clause.vue?vue&type=script&lang=js&"
import style0 from "./Clause.vue?vue&type=style&index=0&id=0f767622&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f767622",
  null
  
)

export default component.exports